import React from 'react';
import styles from './Loader.module.scss';
import { RotatingLines } from 'react-loader-spinner';

export const Loader = () => {
    return (
        <div className={styles.container}>
            <RotatingLines strokeColor="grey" strokeWidth="5" animationDuration="0.75" width="36" visible={true} />
        </div>
    );
};
